<template>
  <div class="headerCommon">
    <div class="header" :class="{IsFixed : this.searchBarFixed}" @mouseenter="headerEnter(fixFlag)"
         @mouseleave="headerOut(fixFlag)"
         @touchstart="headerEnter(fixFlag)">
      <div class=" clearfix rel header-content">
        <a class="header-logo cp" :href="goSelf('/index')">
          <img v-if="this.searchBarFixed" src="../../assets/img/index/logo_new.svg" alt="logo"/>
          <img v-else src="../../assets/img/index/logo_white.svg" alt="logo"/>
        </a>
        <div class="header-title">
          <div class="header-nav">
            <ul class="clearfix header-nav-ul">
              <li class="header-nav-li" v-for="(item, index) in headerNav" :key="index" v-if="headerNav.length>0">
                <a :href="goSelf(item.link)"
                   class="cp nav-item" :class="item.status === '0'? 'dn' : 'db'">{{item.name}}</a>
                <div class="collapse" v-if="item.status === '1' && item.s.length > 0  && searchBarFixed">
                  <div class="collapse-w">
                    <ul class="clearfix collapse-ul">
                      <li class="collapse-ul-li"
                          v-for="(list, idex) in item.s" :key="idex">
                        <div class="clearfix car-collapse-title">
                          <div class="fl icon">
                            <img v-if="list.name === '产品套件' " src="../../assets/img/header/icon2.png" alt="产品套件"/>
                            <img v-if="list.name === '甄采云' " src="../../assets/img/header/icon1.png"
                                 alt="甄采云"/>
                            <img v-if="list.name === '系统 / 平台集成' " src="../../assets/img/header/icon4.png"
                                 alt="系统 / 平台集成"/>
                            <img v-if="list.name === '我的角色' " src="../../assets/img/header/icon3.png" alt="我的角色"/>
                          </div>
                          <div
                            class="fl title" :class="list.status === '0'? 'dn' : 'db'">
                            <div class="noHover list-name"
                                 v-show="list.status === '1' && list.s.length >0"
                            >{{list.name}}
                            </div>
                            <a class="cp normal"
                               :href="goSelf(list.link)" v-show="list.status === '1' && list.s.length === 0"
                            >{{list.name}}</a>
                          </div>
                        </div>
                        <div class="item-list" v-if="list.s.length > 0 && list.status === '1'">
                          <a class="cp item-list-a"
                             :href="goSelf(nav.link)"
                             v-show="nav.status === '1'"
                             v-for="(nav, id) in list.s" :key="id">
                            <span>{{nav.name}}</span>
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="header-tel">
            <span class="span-one" :class="{IsColor : this.searchBarFixed}">服务热线：400-116-0808</span>
            <span class="span-two">
          <span>CH</span>
          <span>/</span>
          <span>EN</span>
          </span>
          </div>
          <div class="header-right-code">
            <span class="header-right-code-text">获取资料</span>
            <div class="header-right-code-img">
              <div class="header-right-code-img-triangle"></div>
            </div>
            <div class="header-right-img-wei"></div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  inject: ['reload', 'goRooter', 'goSelf'],
  data () {
    return {
      searchBarFixed: false,
      headerCon: [],
      headerNav: this.$store.state.header || [],
      Isheader: false,
      whiteList: ['DataDownloadDetail', 'NotFound', 'ServiceUnavailable', 'ClienteleDetile', 'CompanyDetail'],
      routerName: '',
      fixedFlag: true
    }
  },
  methods: {
    handleScroll () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.Isheader === true) {
      } else {
        if (scrollTop > 50) {
          this.searchBarFixed = true
        } else {
          this.searchBarFixed = false
        }
      }
    },
    // 导航菜单
    getHeaderDate () {
      this.$api.post('/base/header_nav', '', (r) => {
        if (r.code === 0) {
          this.headerNav = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    headerEnter (bool) {
      this.Isheader = true
      if (bool) {
        this.searchBarFixed = true
      }
    },
    headerOut (bool) {
      this.Isheader = false
      if (bool) {
        this.searchBarFixed = false
        this.handleScroll()
      }
    },
    checkHeader (name) {
      var routeName = name

      function isWhiteList (str) {
        return str === routeName
      }

      let result = this.whiteList.findIndex(isWhiteList)
      if (result >= 0) {
        this.searchBarFixed = true
        this.Isheader = true
        this.fixFlag = false
        window.removeEventListener('scroll', this.handleScroll)
      } else {
        this.searchBarFixed = false
        this.Isheader = false
        this.fixFlag = true
        window.addEventListener('scroll', this.handleScroll)
      }
    }
  },
  updated () {
  },
  mounted () {
    if (!this.headerNav.length) {
      this.getHeaderDate()
    }
    this.checkHeader(this.$route.name)
  },
  activated () {
  },
  components: {}
}
</script>
<style lang="scss">
  .headerCommon {
    position: relative;
    min-width: 1200px;

    .db {
      display: block;
    }

    .dn {
      display: none;
    }

    .header-nav {
      height: 45px;

      .header-nav-ul {
        .normal {
          font-size: 16px;
        }

        .noHover {
          color: #666;
        }

        .header-nav-li {
          float: left;
          line-height: 45px;
          padding: 0 37px;
          font-size: 16px;

          .nav-item {
            color: #fff;
            display: inline-block;
          }

          &:hover {
            /*border-bottom: 2px solid #4cbace;*/
            .nav-item {
              color: #4cbace;
            }

            .collapse {
              height: auto;
              overflow: auto;
            }
          }

          .collapse {
            position: absolute;
            top: 55px;
            right: 0;
            background: #f5f5f5;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            height: 0;
            overflow: hidden;
            -webkit-transition: all 1000ms ease-out;
            transition: all 1000ms ease-out;
            -webkit-transition-delay: 1s;
            transition-delay: 1s;
            -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

            .collapse-w {
              position: relative;
              min-width: 250px;
              max-width: 100%;
              right: 0;
            }

            .collapse-ul {
              padding: 20px 0;
            }

            .collapse-ul-li {
              float: left;
              padding: 0 50px;
              line-height: 40px;
            }

            .car-collapse-title {
              font-size: 18px;
              color: #666;

              .list-name {
                margin-bottom: 5px;
              }

              .title {
                margin: 3px 0 0 10px;

                &:hover {
                  color: #4CBACE;
                }
              }
            }

            .item-list {
              margin-left: 30px;

              .item-list-a {
                color: #999;
                margin-bottom: 16px;
                height: 20px;
                line-height: 20px;
                display: block;

                &:hover {
                  color: #4CBACE;
                }
              }
            }
          }
        }
      }
    }

    .IsFixed {
      .header-nav .header-nav-ul .header-nav-li {
        .nav-item {
          color: #333;

          &:hover {
            color: #4CBACE;
          }
        }
      }
    }

    .header {
      width: 100%;
      height: 72px;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1);
      color: #FFFFFF;
      position: fixed;
      z-index: 999;
    }

    .IsFixed {
      background-color: #fff;
      color: #333 !important;
      box-shadow: 0 3px 6px 0 rgba(40, 41, 41, 0.14);
      z-index: 999;
      opacity: 0.9;
    }

    .IsColor {
      color: #999999;
    }

    .header-content {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      padding: 23px 0;
    }
    .header-right-code{
      width: 104px;
      height: 45px;
      font-size: 16px;
      margin-left: 30px;
      position: relative;
    }
    .header-right-code-img{
      width: 200px;
      height: 200px;
      padding: 10px;
      background: #F4F4F4 url("../../assets/img/header/erweima.jpg") no-repeat center;
      background-size: 90%;
      -webkit-background-size: 90%;
      -o-background-size: 90%;
      position: absolute;
      top: 59px;
      right: 0;
      z-index: 9999;
      display: none;
    }
    .header-right-code-img-triangle{
      width:0;
      height:0;
      border:20px solid transparent;
      border-bottom-color:#F4F4F4;
      position: relative;
      top: -27%;
      left:55%;
      z-index: 9999;
      display: none;
    }
    .header-right-code:hover {
      .header-right-code-img{
        display: block;
      }
      .header-right-code-img-triangle{
        display: block;
      }
    }
    .header-right-code-text{
      position: absolute;
      top: 50%;
      left: 0;
      transform: translatey(-50%);
    }
    .header-right-img-wei{
      position: absolute;
      top: 50%;
      right: 0;
      transform: translatey(-50%);
      width: 35px;
      height: 35px;
      background:url("../../assets/img/header/weixin.svg") no-repeat center;
      background-size: cover;
      -webkit-background-size: cover;
      -o-background-size: cover;
    }

    .header-logo {
      width: 160px;
    }

    .header-title {
      float: right;
      margin-top: -10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .header-tel {
      font-size: 14px;
      border: 1px solid #29BECE;
      border-radius: 15px;
    }

    .span-one {
      display: inline-block;
      padding: 6px 12px;
      font-size: 12px;
      color: #29BECE;
      letter-spacing: 0;
    }

    .span-two {
      display: none;
    }

    .span-two span:nth-child(1) {
      color: #F4B631 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// header.vue?208314c4